import es from "./es";
import en from "./en";

const shared = {
  es,
  en,
};

export default shared;
